module.exports = __webpack_public_path__ + "revicons.17629a5dfe0d3c3946cf.ttf";


//////////////////
// WEBPACK FOOTER
// D:/ptrans/front-end-customer/src/assets/components/revolution_slider/fonts/revicons/revicons.ttf?5510888
// module id = ../../../../../src/assets/components/revolution_slider/fonts/revicons/revicons.ttf?5510888
// module chunks = 2